import { FC, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { copy } from "shared/assets";
import { DeleteModal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";
import {
  dataMetaSelector,
  deleteInfoBlock,
  DeleteInfoBlockActionProps,
} from "Venues/state";
import { VENUE_ACTIONS } from "Venues/types";
import { useClearActionMetaOnUnMount, getInfoBlockItem } from "Venues/utils";

interface DeleteInfoBlockProps {
  infoBlockData: DeleteInfoBlockActionProps;
  handleClose: () => void;
}

export const DeleteInfoBlockModal: FC<DeleteInfoBlockProps> = ({
  infoBlockData,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { api: apiMeta } = useSelector(
    dataMetaSelector(VENUE_ACTIONS.deleteInfoBlock)
  );
  useClearActionMetaOnUnMount(VENUE_ACTIONS.deleteInfoBlock);

  const infoBlockType = useMemo(
    () => getInfoBlockItem(infoBlockData.type),
    [infoBlockData.type]
  );

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: copy.actions.deleted,
        })
      );
      handleClose();
    }
  }, [apiMeta, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(deleteInfoBlock(infoBlockData));
  };

  if (!infoBlockType) return null;

  return (
    <DeleteModal
      type={copy.infoBlockProperties.infoBlock.title}
      name={`${infoBlockType?.parentLabel}: ${infoBlockType?.label}`}
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
    />
  );
};
